<ng-template cdkPortal #backdropPortal="cdkPortal">
  <div
    class="pg-select-backdrop grit-select-backdrop"
    (click)="this.hideOptions()"
    #backdrop
    [@transitionBackdrop]="this.state"
  ></div>
</ng-template>
<div class="pg-select-label grit-select-label " (click)="this.showOptions()" #label>
  {{ getSelectDisplay()
  }}<span style="font-size: 10px; margin-left: 8px;">&#9660;</span>
</div>
<ng-template cdkPortal #selectPortal="cdkPortal">
  <div
    class="pg-select-options grit-select-options"
    [@transitionOptions]="this.transitionOptionsState"
    #options
  >
    <ng-content select="[pgOption], [gritOption]"> </ng-content>
  </div>
</ng-template>
